import React, { FC, ReactElement } from 'react';
import { SxProps, Theme, Tooltip } from '@mui/material';

import './ToolTip.scss';

type ToolTipProps = {
  children: ReactElement;
  title: string;
  offset?: [number, number];
  tooltipStyles?: SxProps<Theme>;
  arrow?: boolean;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start'
    | undefined;
};

const ToolTip: FC<ToolTipProps> = ({
  offset = [0, 0],
  children,
  title,
  tooltipStyles,
  placement = 'bottom',
  arrow = false,
}) => (
  <Tooltip
    title={title}
    placement={placement}
    arrow={arrow}
    slotProps={{
      tooltip: {
        sx: {
          backgroundColor: 'rgba(0,0,0,0.2)',
          color: 'white',
          fontSize: '12px',
          maxWidth: '350px',
          ...tooltipStyles,
        },
      },
      arrow: {
        sx: {
          color: 'rgba(0,0,0,0.2)',
        },
      },
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: offset,
            },
          },
        ],
      },
    }}
  >
    {children}
  </Tooltip>
);

export default ToolTip;
